import { render, staticRenderFns } from "./Mch.vue?vue&type=template&id=6d08da27&scoped=true"
import script from "./Mch.vue?vue&type=script&lang=js"
export * from "./Mch.vue?vue&type=script&lang=js"
import style0 from "./Mch.vue?vue&type=style&index=0&id=6d08da27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08da27",
  null
  
)

export default component.exports